import { FundraisingEventTeamListItemFieldsFragment } from 'api-graphql-types'
import { FundraisingEventTeamListProps } from '../types'

export type VisibleFundraisingTeamEvent = FundraisingEventTeamListItemFieldsFragment & {
  isMainEvent: boolean
}

function prioritizeCurrentEvent(
  events: FundraisingEventTeamListItemFieldsFragment[],
  currentEventId: string
): FundraisingEventTeamListItemFieldsFragment[] {
  const currentEvent = events.find((event) => event.id === currentEventId)

  if (!currentEvent) {
    return events
  }

  const otherEvents = events.filter((event) => event.id !== currentEventId)
  return [currentEvent, ...otherEvents]
}

function formatVisibleEvents(
  mainEvent: FundraisingEventTeamListItemFieldsFragment,
  supportingEvents: FundraisingEventTeamListItemFieldsFragment[]
): VisibleFundraisingTeamEvent[] {
  const formattedMainEvent = {
    ...mainEvent,
    isMainEvent: true,
  }

  const formattedSupportingEvents = supportingEvents.map((event) => ({
    ...event,
    isMainEvent: false,
  }))

  return [formattedMainEvent, ...formattedSupportingEvents]
}

function getOrderedEvents({
  mainEvent,
  supportingEvents = [],
  id: currentEventId,
  maxVisible,
}: FundraisingEventTeamListProps & { maxVisible: number }) {
  const teamSize = supportingEvents.length + 1
  const showMoreAmount = Math.max(0, teamSize - maxVisible)

  const orderedSupportingEvents =
    mainEvent.id === currentEventId ? supportingEvents : prioritizeCurrentEvent(supportingEvents, currentEventId)

  // Slicing (subtract 1 because mainEvent takes the first slot)
  const visibleSupportingEvents = orderedSupportingEvents.slice(0, Math.max(0, maxVisible - 1))

  const orderedEvents = formatVisibleEvents(mainEvent, visibleSupportingEvents)

  return {
    teamSize,
    showMoreAmount,
    orderedEvents,
  }
}

export default getOrderedEvents
